import axios from "axios";
import { useAuthStore } from "@/store/auth";
import { useToast } from "vue-toastification";
import { GeneratedApi } from "@/utils/functions/api-wrapper";


export default defineNuxtPlugin({
  name: "api",
  parallel: true,
  order: 1,

  setup() {
    const toast = useToast();
    const authStore = useAuthStore();
    const runtimeConfig = useRuntimeConfig();
    const destination = runtimeConfig.public.Api as string;
    const api = new GeneratedApi(destination);

    api.instance.interceptors.request.use(
      async (config: any) => {
        const accessToken = authStore.getToken();
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
      },
      (error: any) => error
    );

    api.instance.interceptors.response.use(
      (response: any) => response,
      (error: any) => {
        // implementing refresh token call
        const { config, response } = error;
        const originalRequest = config;

        if (response.status === 401) {
          toast.error("لطفا دوباره وارد سامانه شوید");
          authStore.logout();
          navigateTo("/new/sign-in");
          throw error;
          // if (response?.data?.message === "Credentials are not correct") {
          // }
          // 👉 detect user type
          // const userType =
          //     error?.response?.data?.message?.split(" ")[0] ?? "Agent";

          // 👉 try to refresh the token
          // authStore
          //   .refreshUserToken(userType)
          //   .then((res: any) => {
          //     if (!res) {
          //       authStore.removeSubscribers();
          //       authStore.logout(userType);
          //     }
          //   })
          //   .catch((err: any) => {
          //     console.log("error refresh token: ", err);
          //   });

          // return new Promise((resolve) => {
          // authStore.addSubscriber((accessToken: string) => {
          //   originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          //   resolve(axiosIns(originalRequest));
          // });
          // });
        }

        // displaying toast if error was on client
        if (import.meta.client) {
          if (typeof error?.response?.data?.displayMessage === "string") {
            toast.error(error?.response?.data?.displayMessage);
          } else if (Array.isArray(error?.response?.data?.displayMessage)) {
            error?.response?.data?.message.forEach((message: string) => {
              toast.error(message);
            });
          } else {
            const extraInfo = error?.response?.data?.message;
            toast.error(extraInfo ? extraInfo : 'خطایی رخ داده است');
          }
        }
        throw error;
      }
    );

    return { provide: { api: api } };
  },
});

declare module "#app" {
  interface NuxtApp {
    $api: GeneratedApi<unknown>;
  }
}

declare module "vue" {
  interface ComponentCustomProperties {
    $api: GeneratedApi<unknown>;
  }
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $api: GeneratedApi<unknown>;
  }
}

export {};
